export function isInternalLink(href: string) {
  return /^(\/([^\/]|$)|((https?:)?\/\/)?(www\.)?mellon\.org)/.test(href);
}
